import React, { Component, PropTypes } from 'react';
import reactCookie from 'react-cookie';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { envValue } from '../../../../../config/envUtils';
import { FileService } from '../../../../services/fileUpload/uploadFile';
import { httpClient } from '../../../../../lib/utils';
const SOURCEURL = envValue('SOURCEURL');
const auth = reactCookie.load('auth', false);

class FileTransportIFrame extends Component {
    static propTypes = {
        onProgress: PropTypes.func,
        onUploadStart: PropTypes.func,
        onError: PropTypes.func,
        onComplete: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            files: [],
            fileProgress: [],
            totalProgress: 0.0
        };
        this.formRef = {};
    }

    componentDidMount() {
        if (this.props.setImplementation) {
            this.props.setImplementation(this);
        }
    }
    componentWillUnmount() {
        this.resolvePromise = undefined;
        this.rejectPromise = undefined;
    }
    componentDidUpdate(prevProps, prevState) {}

    reloadFileList() {
        const { chainId, hotelId, level, category } = this.props;
        return FileService.getList(chainId, hotelId, level, category);
    }

    progressHandler(progress) {
        if (this.props.onProgress) {
            this.props.onProgress(this.state.totalProgress);
        }
    }

    onComplete() {
        if (this.props.onComplete) {
            this.props.onComplete();
        }
        this.reloadFileList();
    }

    onError(error) {
        if (this.props.onError) {
            this.props.onError(error);
        }
        this.reloadFileList();
    }

    iframeHandler(event) {
        try {
            let content = event.target.contentDocument || event.target.contentWindow.document;
            if (content !== '') {
            }
        } catch (err) {
            //cors issue probably
        }
    }

    fileChosen(event) {
        const { chainId, hotelId, level } = this.props;
        if (event.target.files && event.target.files.length) {
            if (this.props.onUploadStart) {
                this.props.onUploadStart();
            }
            const files = [...event.target.files];
            let totalSize = files.reduce((totalSize, file) => totalSize + file.size, 0);
            this.setState({
                files: files.map(file => Object.assign(file, { weight: Math.max(1.0, file.size) / totalSize })),
                fileProgress: files.map(file => 0.0)
            });
            this.formRef.form.action = `${SOURCEURL}/shs-bedesigner-services/files?${FileService.fileParamProxy(
                chainId,
                hotelId,
                null,
                level,
                files[0]['name']
            )}`;
            this.progressHandler(-1);
            let onComplete = () => {
                this.onComplete();
                this.formRef.iframe.removeEventListener('load', onComplete);
            };
            this.formRef.iframe.addEventListener('load', onComplete);
            this.formRef.auth.value = httpClient.defaults.headers.common.Authorization;
            this.formRef.form.submit();
        } else {
            this.onComplete();
        }
    }

    //{}
    render() {
        this.formRef = {};
        return (
            <div>
                <form
                    style={{ display: 'none' }}
                    target={`fileIFrame`}
                    ref={node => (this.formRef.form = node)}
                    action=""
                    method="post"
                    encType="multipart/form-data"
                >
                    <input
                        type="file"
                        ref={node => (this.formRef.input = node)}
                        onChange={event => this.fileChosen(event)}
                        name="file"
                    />
                    <input
                        type="hidden"
                        ref={node => (this.formRef.auth = node)}
                        name="Authorization"
                        value={`${httpClient.defaults.headers.common.Authorization}`}
                    />
                </form>
                <iframe
                    style={{ display: 'none' }}
                    name={`fileIFrame`}
                    ref={node => (this.formRef.iframe = node)}
                ></iframe>
                <button
                    className="spark-btn spark-btn--sm align-middle"
                    type="button"
                    onClick={() => {
                        this.formRef.input.click();
                    }}
                >
                    UPLOAD
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level
    };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileTransportIFrame);



// WEBPACK FOOTER //
// ./src/components/widgets/FileTransportProxy/adapter/FileTransportIFrame.js